import { z } from 'zod';

export const AFFIDAVIT_MODE_OPTIONS = [
  { label: 'Blank', value: 'blank' },
  { label: 'Complete', value: 'complete' },
] as const;

export const exportFilePackageSchema = z.object({
  workOrders: z.array(
    z.object({
      workOrderId: z.string(),
      affidavitMode: z.enum(['blank', 'complete'], {
        required_error: 'Affidavit Mode is required',
        invalid_type_error: 'Affidavit Mode is required',
      }),
      affidavitCode: z.string({ required_error: 'Affidavit is required' }).min(1, 'Affidavit is required'),
    })
  ),
});

export type ExportFilePackageForm = z.infer<typeof exportFilePackageSchema>;
